module.exports = {"DATE_SELECT_DAY":"Ngày","DATE_SELECT_MONTH":"Tháng","DATE_SELECT_YEAR":"Năm"}